import { defineComponent as _defineComponent } from 'vue'
import { useSlots } from 'vue';
import { Fragment } from 'vue-fragment';


export default /*#__PURE__*/_defineComponent({
  __name: 'input-group',
  props: {
    hideGroup: { type: Boolean },
    groupClass: null
  },
  setup(__props: any) {

const props = __props as {
    hideGroup?: boolean;
    groupClass?: 'input-group-lg' | 'input-group-sm';
}


const slots = useSlots();

return { __sfc: true,props, slots, Fragment }
}

})